import { render } from "./approvals.vue?vue&type=template&id=587895f8&scoped=true"
import script from "./approvals.vue?vue&type=script&lang=js"
export * from "./approvals.vue?vue&type=script&lang=js"

import "./approvals.vue?vue&type=style&index=0&id=587895f8&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-587895f8"]])

export default __exports__